import { combineReducers } from 'redux';
import { IntlReducer as Intl } from 'react-redux-multilingual'
import { auth_reducer, product_reducer, cart_reducer, wishlist_reducer, global_reducer, order_reducer, adcard_reducer,notification_reducer } from "../redux-store"
// Import custom components
import productReducer from './products';
import cartReducer from './cart';
import filtersReducer from './filters';
import wishlistReducer from './wishlist';
import compareReducer from './compare';
import { payment_reducer } from '../redux-store/paymentMethod/reducer';


const rootReducer = combineReducers({
    data: productReducer,
    cartList: cartReducer,
    filters: filtersReducer,
    notifications:notification_reducer,
    wishlist: wishlistReducer,
    compare: compareReducer,
    auth: auth_reducer,
    products: product_reducer,
    cart: cart_reducer,
    wishlist_: wishlist_reducer,
    order: order_reducer,
    adcard: adcard_reducer,
    global: global_reducer,
    payment: payment_reducer,
    Intl
});

export default rootReducer;